export default "__VITE_ASSET__BA_nDpvY__"